import { LayoutVerticalPreviewWebComponents } from './LayoutVerticalPreviewWebComponents';
import { LayoutViewWebComponents } from './LayoutViewWebComponents';
import { ProcessFieldDynamicDisplayWebComponents } from './ProcessFieldDynamicDisplayWebComponents';
import { ReceptionScheduleDetailsWebComponent } from './ReceptionScheduleDetailsWebComponent';
import { WrapperWebComponents } from './Wrapper';

import r2wc from '@r2wc/react-to-web-component';

const LayoutView = r2wc(WrapperWebComponents(LayoutViewWebComponents), {
    props: {
        active: 'boolean',
        fileUploadController: 'string',
        layoutProcess: 'json',
        service: 'json',
        tabProps: 'json',
        lng: 'string',
        mobileSignUrls: 'json',
        openUri: 'method',
        theme: 'string',
        layoutVariant: 'string',
        serverValidationErrors: 'json',
        accessToken: 'string',
        getAccessToken: 'method',
    },
    shadow: 'open',
});

const LayoutVerticalPreview = r2wc(
    WrapperWebComponents(LayoutVerticalPreviewWebComponents),
    {
        props: {
            fileUploadController: 'string',
            layoutProcess: 'json',
            service: 'json',
            tabProps: 'json',
            lng: 'string',
            mobileSignUrls: 'json',
            theme: 'string',
            serverValidationErrors: 'json',
            accessToken: 'string',
            getAccessToken: 'method',
        },
        shadow: 'open',
    },
);

const ProcessFieldDynamicDisplay = r2wc(
    WrapperWebComponents(ProcessFieldDynamicDisplayWebComponents),
    {
        props: {
            processFieldId: 'string',
            variant: 'string',
            aiChatShowSearch: 'boolean',
            field: 'json',
            value: 'json',
            defaultValues: 'json',
            service: 'json',
            name: 'string',
            disabled: 'boolean',
            readOnly: 'boolean',
            required: 'boolean',
            isViewHaveValue: 'boolean',
            lng: 'string',
            theme: 'string',
            onValueChange: 'method',
        },
        shadow: 'open',
    },
);

const ReceptionScheduleDetails = r2wc(
    WrapperWebComponents(ReceptionScheduleDetailsWebComponent),
    {
        props: {
            service: 'json',
            lng: 'string',
            theme: 'string',
            hideTimer: 'boolean',
        },
        shadow: 'open',
    },
);

if (!customElements.get('layout-view')) {
    customElements.define('layout-view', LayoutView);
}

if (!customElements.get('layout-vertical-preview')) {
    customElements.define('layout-vertical-preview', LayoutVerticalPreview);
}

if (!customElements.get('process-field-dynamic-display')) {
    customElements.define(
        'process-field-dynamic-display',
        ProcessFieldDynamicDisplay,
    );
}

if (!customElements.get('reception-schedule-details')) {
    customElements.define(
        'reception-schedule-details',
        ReceptionScheduleDetails,
    );
}
